// extracted by mini-css-extract-plugin
module.exports = {"bookingsHeaderHolder":"BookingItemsDisplay_bookingsHeaderHolder__rE1VC","bookingsHolder":"BookingItemsDisplay_bookingsHolder__2VQkI"};